var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49288 0.50674C7.62713 0.50674 5.88771 1.05111 4.41893 1.98485L2.43408 0V5.56102H7.9951L5.78761 3.35353C6.88531 2.73667 8.14664 2.38009 9.49288 2.38009C13.6942 2.38009 17.1123 5.79817 17.1123 9.99983C17.1123 11.0005 16.9131 11.955 16.5603 12.8311L18.1958 13.7845C18.7033 12.6236 18.9856 11.3447 18.9856 9.99983C18.9856 4.76536 14.727 0.50674 9.49288 0.50674Z",
    fill: "#cd2a3f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1956 16.6436C12.0982 17.2602 10.8393 17.6195 9.49309 17.6195C5.29177 17.6195 1.87369 14.2014 1.87369 10.0001C1.87369 9.05463 2.05457 8.15334 2.37042 7.31763L0.737327 6.3335C0.26269 7.46261 0 8.70081 0 10.0001C0 15.2346 4.25827 19.4929 9.49274 19.4929C11.3588 19.4929 13.0945 18.9461 14.5639 18.0123L16.5515 20.0003V14.4386H10.9902L13.1956 16.6436Z",
    fill: "#cd2a3f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.21de760edc3aee0b4ebf24912bcc523e.svg";
export { ForwardRef as ReactComponent };